// extracted by mini-css-extract-plugin
module.exports = {"root":"Profile_root__rHgE7","initials":"Profile_initials__MkrjV","nick":"Profile_nick__miQXl","username":"Profile_username__LXl1t"};